module.exports = __webpack_public_path__ + "media/images/question-mark-mbd-66fe6377e8994618a2790109cca0baba.svg";